import classNames from "classnames";
import { setTrackingId } from "client/Misc/utils";
import {
	PropsWithChildren,
	ReactElement,
	useContext
} from "react";
import styles from "./DialogBody.module.less";
import { DialogContext } from "../Dialog";

export type DialogBodyProps = {
	goesEdgeToEdge?: boolean;
};

export const DialogBody = (props: PropsWithChildren<DialogBodyProps>): ReactElement => {
	const {
		children,
		goesEdgeToEdge = false
	} = props;

	const {
		shouldBodyHaveVerticalPadding
	} = useContext(DialogContext);

	return (
		<div {...setTrackingId("dialog-body")} className={classNames(
			[styles.root],
			{
				[styles.root_edgeToEdge]: goesEdgeToEdge,
				[styles.root_verticalPadding]: shouldBodyHaveVerticalPadding
			}
		)}>
			{children}
		</div>
	);
};

DialogBody.displayName = "Dialog.Body";
